import { FC } from 'react'

import { Avatar, Box, Text, tokens } from '@factorialco/deprecated-design-system'
import { RawTag } from '@factorialco/factorial-one-react/dist/experimental'
import { Masonry, People, Person } from '@factorialco/factorial-one-react/icons/app'

import { JobCatalogNodeData } from 'modules/job_catalog/pages/JobCatalogTreePage/types'

import { NODE_SIZE } from '../../../hooks/useJobCatalogTree'
import CollapsibleButton from '../CollapsibleButton'
import Line from '../Line'

interface NodeBaseProps {
  data: JobCatalogNodeData
  x: number
  y: number
  onClick?: () => void
  isUncollapsed?: boolean
  hasChildren?: boolean
  onCollapseChange?: () => void
  childrenCount?: number
  isSelected?: boolean
}

interface JobCatalogNodeComponent extends FC<NodeBaseProps> {
  Link: FC<{ d: string }>
}

const JobCatalogNode: JobCatalogNodeComponent = ({
  data,
  x,
  y,
  onClick,
  isUncollapsed = false,
  hasChildren = false,
  onCollapseChange = () => {},
  childrenCount = 0,
  isSelected = false,
}) => {
  const [width, height] = NODE_SIZE

  const iconMap = {
    family: People,
    function: Masonry,
    role: Person,
  }

  const isValidType = (type: string): type is keyof typeof iconMap => type in iconMap
  const icon = isValidType(data.type) ? iconMap[data.type] : Person

  return (
    <foreignObject x={x} y={y} width={width} height={height} style={{ overflow: 'visible' }}>
      <Box padding="s12" justifyContent="center" alignItems="center">
        <Box
          position="relative"
          onClick={onClick}
          border={isSelected ? { all: { color: 'viridian800', style: 'solid', width: 's4' } } : {}}
          borderRadius={{ all: 'rel333' }}
          padding="s2"
        >
          <Avatar size="s64" label={data.name} />
        </Box>
        <Text weight="semibold" size="300" whiteSpace="nowrap" ellipsis color="grey1000">
          {data.name}
        </Text>
        <RawTag text={data.type} icon={icon} />
        {hasChildren && (
          <>
            <Line />
            <CollapsibleButton
              childrenCount={childrenCount}
              isUncollapsed={isUncollapsed}
              onCollapseChange={onCollapseChange}
            />
          </>
        )}
      </Box>
    </foreignObject>
  )
}

const Link: FC<{ d: string }> = ({ d }) => {
  return <path d={d} fill="none" stroke={tokens.colors.grey400} strokeWidth="2" />
}

JobCatalogNode.Link = Link

export default JobCatalogNode
